import { LocationResponse } from "pages/api/detect-location";
import { createContext, useEffect, useState } from "react";
import { fetchApi } from "services/fetch-api";
import { logger } from "utils/logger";

export type IpLocation = ReturnType<typeof useLocationDetector>;

export const IpLocationContext = createContext<IpLocation>({} as IpLocation);

export function useLocationDetector(props?: { disable?: boolean }) {
  const [locationData, setLocationData] = useState<LocationResponse>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (
      window.location.pathname.startsWith("/app") ||
      window.location.pathname.startsWith("/hub")
    ) {
      return;
    }

    async function fetchLocation() {
      try {
        const data = await fetchApi<LocationResponse>("/detect-location");
        setLocationData(data);
      } catch (err: any) {
        logger.error(`Error fetching location: ${err?.message}`);
      } finally {
        setIsLoading(false);
      }
    }

    if (props?.disable) {
      // no need to pay for location detection if not needed
      return;
    }

    fetchLocation();
  }, [props?.disable]);

  return { ...locationData, isLoading };
}
